module.exports = __webpack_public_path__ + "static/media/banner1.a7b7b558.png";